import { useEffect, useRef, useState } from "react";
import { getFields } from "../../services/api";
import { useQuery } from "@tanstack/react-query";
import AddNewFieldButton from "./components/AddNewFieldButton";
import { Button, Tour } from "antd";
import { steps } from "../../tour_steps/fields";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { sideMenuContent } from "@helpers/sideMenu";
import { useLocation } from "react-router-dom";
import FieldCard from "./components/FieldCard";
import FieldEmpty from "@/features/farm/presentation/components/EmptyFarm";

function Fields({ setFarmerFieldsState }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [fields, setFields] = useState(null);
  const fieldsQuery = useQuery(["farmersFields", "fields"], getFields);
  const ref2 = useRef(null);
  useEffect(() => {
    if (fieldsQuery?.data) {
      setFields(
        fieldsQuery?.data?.farms?.map((field, index) => (
          <FieldCard
            key={index}
            index={index}
            field={field}
            setFarmerFieldsState={setFarmerFieldsState}
          />
        ))
      );
    }
  }, [fieldsQuery?.data]);

  const ref1 = useRef(null);

  return (
    <div className="flex flex-col gap-8 w-full justify-center items-center font-body">
      {sideMenuContent(
        location.pathname,
        "nullUndefined",
        false,
        undefined,
        undefined,
        true,
        false
      )}

      <Button
        className="circle-neo flex items-center justify-center text-[#008a44] hover:!text-[#50aa44] font-bold absolute left-0 bottom-28 !rounded-l-none !rounded-r-xl z-[99999]"
        icon={<QuestionCircleOutlined className="text-base" />}
        onClick={() => setOpen(true)}
      >
        راهنما
      </Button>
      {fieldsQuery?.isLoading ? (
        <p className="text-2xl text-[#404848] animate-pulse my-16">
          در حال دریافت اطلاعات
        </p>
      ) : fieldsQuery?.data ? (
        <>
          <AddNewFieldButton
            ref1={ref1}
            setFarmerFieldsState={setFarmerFieldsState}
          />
          {fields?.length === 0 ? (
            <FieldEmpty ref2={ref2} />
          ) : (
            <div ref={ref2}>{fields}</div>
          )}
        </>
      ) : (
        <></>
      )}
      {open ? (
        <Tour
          type="primary"
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          steps={steps(ref1, ref2)}
        />
      ) : null}
    </div>
  );
}

export default Fields;
